import { Controller } from "stimulus";

export default class extends Controller {

  static get targets() {
    return [
        'secondaryContent',
        'navToggle',
        'navAccordion',
        'navAccordionToggle',
        'navSubAccordion',
        'navSubAccordionToggle',
    ];
  }

  initialize() {
    this.hideClass = 'site-header-hide';
    this.showClass = 'site-header-show';
    this.scrolledPastHeroClass = 'scrolled-past-hero';
    const breakpointEm = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--desktop-breakpoint-em')) || 85.375;
    this.desktopMediaQuery = window.matchMedia(`(min-width: ${breakpointEm}em)`);
    window.addEventListener('scroll', () => this.onScroll(), {passive: true});
    document.body.classList.add('is-initial-scroll-position');

    // Check if we're on a geographic area page and find the hero element
    this.isGeographicAreaPage = document.body.dataset.docType === 'geographicArea';
    this.heroElement = document.querySelector('.hero, .hero-v2');

    this.onScroll();

    this.navAccordionToggleTargets.forEach(toggle => {
      toggle.addEventListener('mouseenter', (e) => this.openDesktopMegaMenu(e));
    });

    // Attach mouseleave to the parent nav item, not just the dropdown list
    // This ensures the dropdown closes when leaving the entire nav item area
    document.querySelectorAll('.site-header__primary-nav__item--mobile-accordion').forEach(item => {
      item.addEventListener('mouseleave', (e) => this.closeDesktopMegaMenu(e));
    });
  }

  onScroll() {
    const currentScroll = window.pageYOffset;

    if(currentScroll <= 0) {
      document.body.classList.add(this.showClass);
      document.body.classList.remove(this.hideClass);
      return;
    }
    if(currentScroll >= 150 && document.body.classList.contains('is-initial-scroll-position')) {
      document.body.classList.remove('is-initial-scroll-position');
    }

    // Geographic area pages: track when scroll passes the hero bottom
    if (this.isGeographicAreaPage && this.heroElement) {
      const heroBottom = this.heroElement.offsetTop + this.heroElement.offsetHeight;
      if (currentScroll >= heroBottom) {
        document.body.classList.add(this.scrolledPastHeroClass);
      } else {
        document.body.classList.remove(this.scrolledPastHeroClass);
      }
    }

    if(currentScroll > this.lastScroll && !document.body.classList.contains(this.hideClass)) {
      // down
      this.slideUp();
    }
    else if(currentScroll < this.lastScroll && document.body.classList.contains(this.hideClass)) {
      // up
      this.slideDown();
    }
    this.lastScroll = currentScroll;
  }

  toggle(e) {
    this.navToggleTargets.forEach(toggle => {
      toggle.setAttribute('aria-expanded', toggle.getAttribute('aria-expanded') !== 'true');
    });
    this.element.classList.toggle('is-open');
    
    if(this.element.dataset.static != undefined) {
      window.scrollTo(0,0);
    }
    
    if(e) {
      document.body.classList.toggle('is-site-nav-open');
    }
  }

  subNavToggle() {
    this.slideDown();
    this.element.classList.toggle('is-subnav-open');
  }

  slideDown() {
    document.body.classList.add(this.showClass);
    document.body.classList.remove(this.hideClass);
  }

  slideUp() {
    document.body.classList.add(this.hideClass);
    document.body.classList.remove(this.showClass);
  }
  
  toggleAccordion(e) {
    const toggle = e.currentTarget;
    const index = this.navAccordionTargets.findIndex(target => target.contains(toggle));
    const accordion = this.navAccordionTargets[index];

    toggle.setAttribute('aria-expanded', toggle.getAttribute('aria-expanded') !== 'true');
    accordion.classList.toggle('is-open');
  }

  openDesktopMegaMenu(e) {
    if (!this.desktopMediaQuery.matches) {
      return;
    }

    const toggle = e.currentTarget;
    const index = this.navAccordionTargets.findIndex(target => target.contains(toggle));
    const accordion = this.navAccordionTargets[index];

    toggle.setAttribute('aria-expanded', 'true');
    accordion.classList.add('is-open');
  }

  closeDesktopMegaMenu(e) {
    if (!this.desktopMediaQuery.matches) {
      return;
    }

    // e.currentTarget is now the .site-header__primary-nav__item element
    const navItem = e.currentTarget.closest('.site-header__primary-nav__item');
    const toggle = navItem.querySelector('.site-header__primary-nav__toggle');

    if (!toggle) {
      return;
    }

    const index = this.navAccordionTargets.findIndex(target => target.contains(toggle));
    const accordion = this.navAccordionTargets[index];

    if (accordion) {
      toggle.setAttribute('aria-expanded', 'false');
      accordion.classList.remove('is-open');
    }
  }

  toggleSubAccordion(e) {
    const toggle = e.currentTarget;
    const parent = toggle.closest('.site-header__primary-nav__mobile-list__item');

    toggle.setAttribute('aria-expanded', toggle.getAttribute('aria-expanded') !== 'true');
    parent.classList.toggle('is-open');
  }
};